import { useContext } from "react"
import { Box, Heading } from "@chakra-ui/react"

import {
  selectDepositActionStatus,
  selectDepositActionToken,
  setActionStatus,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import ModalContainer from "#/shared/components/ModalContainer"
import { FlowContext } from "#/shared/context"
import { useWithdrawalModal } from "#/shared/hooks"
import { MezoModalProps } from "#/shared/types"

import WithdrawalModalCompleted from "./WithdrawalModalCompleted"
import WithdrawalModalForm from "./WithdrawalModalForm"
import WithdrawalModalLeave from "./WithdrawalModalLeave"

export default function WithdrawalModal({ isOpen, onClose }: MezoModalProps) {
  const { showLeaveModal, leaveWithdrawalModalHandler, backToWithdrawalModal } =
    useWithdrawalModal(onClose)

  const { isEthereumFlow } = useContext(FlowContext)

  const withdrawalStatus = useDappSelector(selectDepositActionStatus)

  const token = useDappSelector(selectDepositActionToken)

  const dispatch = useDappDispatch()

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={leaveWithdrawalModalHandler}
      width="800px"
    >
      <Heading variant="h2" color="primary.white.100" mb="45px">
        {token === "BTC" && isEthereumFlow
          ? "Withdraw BTC or tBTC?"
          : "You sure you want to withdraw?"}
      </Heading>

      {withdrawalStatus === "completed" && (
        <WithdrawalModalCompleted onClose={leaveWithdrawalModalHandler} />
      )}
      {withdrawalStatus !== "completed" && showLeaveModal && (
        <WithdrawalModalLeave
          onClose={leaveWithdrawalModalHandler}
          backToProcessTrigger={backToWithdrawalModal}
        />
      )}
      {withdrawalStatus !== "completed" && !showLeaveModal && (
        <Box w="720px" ml="11px" bg="primary.red.100" rounded="24px">
          <Box bg="primary.white.100" rounded="24px" padding="24px 0">
            <WithdrawalModalForm
              onSuccess={() => dispatch(setActionStatus("completed"))}
            />
          </Box>
        </Box>
      )}
    </ModalContainer>
  )
}
